import { Injectable } from '@angular/core';
import { HighlanderHttpService } from '@highlander/services/http.service';
import { UserModel } from '@models/authentication/auth';
import { map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class IdentityService {
  url = `${environment.bffUrl}/auth`;

  constructor(private readonly http: HighlanderHttpService) {}

  login(): Observable<void> {
    return of((document.location.href = `/${environment.bffUrl}/auth/login`)).pipe(map(() => undefined));
  }

  logout(): Observable<void> {
    return of((document.location.href = `/${environment.bffUrl}/auth/logout`)).pipe(map(() => undefined));
  }

  refresh(): Observable<{ expires_at: number }> {
    return this.http.get<{ expires_at: number }>(`${this.url}/refresh`);
  }

  checkAuth(): Observable<UserModel> {
    return this.http.get<UserModel>(`${this.url}/authStatus`, {
      headers: { 'x-skip-interceptor': '' },
    });
  }
}
